import api from "./hiddenFieldApi";
import {
  hiddenFieldsLoading,
  hiddenFieldsLoaded,
  hiddenFieldsError,
  fieldHidden,
  fieldShown,
  fieldToggleVisibilityInit,
  togglingFieldVisibility,
} from "./hiddenFieldStateActions";

export function getHiddenFields() {
  return function (dispatch: any) {
    dispatch(hiddenFieldsLoading());

    api.getHiddenFields().then(
      (response) => {
        dispatch(hiddenFieldsLoaded(response));
      },
      (error) => dispatch(hiddenFieldsError(error.message))
    );
  };
}

// export function getCategories() {
//   return function (dispatch: any) {
//     dispatch(categoriesLoading());

//     api.getConfigurableCategories().then(
//       (response) => {
//         dispatch(categoriesLoaded(response));
//       },
//       (error) => dispatch(categoriesLoadError(error.message))
//     );
//   };
// }

export function hideField(categoryId: number, internalName: string) {
  return function (dispatch: any) {
    dispatch(togglingFieldVisibility());
    api
      .hideField(categoryId)
      .then(
        (response) => {
          dispatch(fieldHidden(response, internalName));
        },
        (error) => dispatch(hiddenFieldsError(error.message))
      )
      .finally(function () {
        setTimeout(() => {
          dispatch(fieldToggleVisibilityInit());
        }, 500);
      });
  };
}

export function showField(hiddenFieldId: number) {
  return function (dispatch: any) {
    dispatch(togglingFieldVisibility());

    api.unHideField(hiddenFieldId).then(
      (response) => {
        if (response > 0) dispatch(fieldShown(hiddenFieldId));
        else {
          dispatch(
            hiddenFieldsError("An error has occurred, please try again.")
          );
        }
      },
      (error) => dispatch(hiddenFieldsError(error.message))
    );
  };
}
